export const MATCH_STATUS_ENDED = 'ended'
export const MATCH_STATUS_LIVE = 'live'
export const MATCH_STATUS_SOON = 'soon'
export const MATCH_STATUS_PENDING = 'pending'
export const TIME_UPDATE_MATCH = 60000
